import React from "react";
import { useSelector } from "react-redux";
import { CircularProgress } from "@material-ui/core";
// Import your local images from assets
import img1 from "../../assets/instagram/insta1.webp";
import img2 from "../../assets/instagram/insta2.webp";
import img3 from "../../assets/instagram/insta3.webp";
import img4 from "../../assets/instagram/insta4.webp";
import img5 from "../../assets/instagram/insta5.webp";
import img6 from "../../assets/instagram/insta6.webp";

import "./styles.css";

const FollowUs = () => {
  // Local array for the 6 photos
  const localImages = [img1, img2, img3, img4, img5, img6];

  const { allDocLoading } = useSelector(
    (state) => state.instagramSlicer
  );

  /* 
   * Responsive logic or API calls can be re-added here if needed.
   * Currently using local assets and CSS for responsiveness.
   */

  return (
    <div className="followContainer mt-5">
      <h2 className="followHeading mb-0">
        COME HANG WITH US ON{' '}
        <a
          href="https://www.instagram.com/madeinheavenweddings_"
          className="instagram-link"
        >
          'GRAM.
        </a>
      </h2>
      <hr className="t_border my-4 ml-0 text-left" />

      {allDocLoading && (
        <div className="loadingContainer">
          <CircularProgress />
        </div>
      )}

      {/* NEW: Instagram Image Grid */}
      <div className="instaGrid">
        {localImages.map((image, index) => (
          <div key={index} className="instaBox">
            <img src={image} alt={`Instagram post ${index + 1}`} className="instaImg" />
          </div>
        ))}
      </div>

      <div className="socials mt-4">
        <p className="link">
          <a href="https://www.instagram.com/madeinheavenweddings_" target="__blank">
            INSTAGRAM
          </a>
        </p>
        <div className="space" />
        <p className="link">
          <a href="https://www.facebook.com/madeinheavenweddings_" target="__blank"> FACEBOOK</a>
        </p>
      </div>
    </div>
  );
};

export default FollowUs;